<script>
import vSelect from 'vue-select'
import {BRow, BCol } from 'bootstrap-vue'
import {Button} from "@core/components/common";
import {legislationTranslationMixin} from "@core/domain/legislation";

export default {
    mixins: [legislationTranslationMixin],
    components: {Button, BRow, BCol, vSelect},
    props: {
        event: {},
        status: {},
        statuses: {
            required: true
        }
    },
    data() {
        return {
            value: this.makeValue()
        };
    },
    methods: {
        remove() {
            this.$emit('remove', this.event)
        },
        makeValue() {
            return {
                id: this.status,
                title: this.$t(this.makeProductStatusTranslationKey(this.status))
            };
        },
        valueChanged() {
            this.$emit('change', this.event, this.value.id);
        }
    },
    watch: {
        status() {
            this.value = this.makeValue();
        }
    }
}
</script>

<template>
    <b-row class="pb-1">
        <b-col md="4" lg="4" class="justify-content-end align-items-center d-flex">
            <div>{{ $t(makeProductEventTranslationKey(event)) }}</div>
        </b-col>
        <b-col md="6" lg="6">
            <v-select
                v-model="value"
                @input="valueChanged"
                label="title"
                :clearable="false"
                :placeholder="$t('Component(Placeholder):statuses')"
                :options="statuses"
            />
        </b-col>
        <b-col class="justify-content-start align-items-center d-flex">
            <Button
                class="btn-icon"
                @click="remove"
            >
                <feather-icon icon="Trash2Icon"/>
            </Button>
        </b-col>
    </b-row>
</template>

<style scoped lang="scss">

</style>
